/* NOTE FROM NADER:
 *
 *
 * This file imports the raw CSS from Jupyter-Dark.css using raw-loader.
 * The imported CSS is then exported as a default export from this module.
 *
 *
 *
 * We do this to inject custom styles into jupyter notebooks that get converted to HTML.
 */

import JupyterDarkCSS from "./Jupyter-Dark.css?raw";

export default JupyterDarkCSS;
